export default {
  header: {
    review_us: 'Recenzează-ne pe Google',
    upload: 'Încarcă recenzia Google',
    not_now: 'Nu acum',
  },
  steps: {
    how_it_works: 'Cum funcționează',
    step_1: {
      title: 'Pasul',
      description: 'Scrie o recenzie despre {{name}} pe Google',
    },
    step_2: {
      title: 'Pasul',
      description: 'Încarcă o captură de ecran a recenziei tale publicate (vezi exemplul de mai jos)',
    },
  },
  buttons: {
    upload_screenshot: 'Încarcă captură de ecran',
    leave_google_review: 'Lasă o recenzie Google',
    submit_screenshot: 'Trimite captură de ecran',
    return: 'Înapoi',
  },
  enter_name: {
    title: 'Numele postat cu recenzia ta Google',
    place_holder: 'Introdu numele',
  },
  screenshot_uploaded: {
    title: 'Captură de ecran încărcată',
    description: 'Derulează în jos pentru a vedea captura completă',
  },
  loading: {
    processing: 'Recenzia ta postată este în curs de verificare',
  },
  error_messages: {
    upload_failed: 'Încărcarea capturii a eșuat. Te rugăm să încerci din nou.',
    review_already_uploaded:
      'Se pare că ai încărcat deja o captură de ecran a unei recenzii Google. Poți fi recompensat maximum o dată pentru o recenzie Google 😊',
    name_missing: {
      description:
        'Te rugăm să introduci numele postat cu recenzia ta Google pentru a ne ajuta să asociem informațiile tale.',
      button: {
        title: 'Ok',
      },
    },
  },
};
